export default "__VITE_ASSET__MW0ZM62___"